import React from "react";

/**
 * Renders trusted CMS HTML produced by the admin RichTextEditor.
 * Content originates from the authenticated admin dashboard only.
 */
const EditableHTML = ({ html, className = "", as: Tag = "div", testId }) => {
  return (
    <Tag
      className={`rich-content ${className}`}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: html || "" }}
    />
  );
};

export default EditableHTML;
